import '../list-price-simulation-table/list-price-simulation.scss';
import './retail-price-simulation.scss';
import { TableState } from '@tanstack/react-table';
import { getDataForEditedSimulatedRows, makeDataForTableNew } from 'src/components/collapsible-table/table-data-prep';
import CollapsibleTable from 'src/components/collapsible-table/collapsible-table';
import { useAppSelector } from 'src/hooks';
import { MODIFIED_ROW_INDICATOR_KEY } from '../../types/generic-table.model';
import TableSkeletonContainer from '../simulation-table-container/table-skeleton';
export default function RetailPriceSimulationTable({ columns, externalRetailerData, visibleColumns, activeHeader }) {
  const { tableMetadaData, outputColumnVisibilityState, isSKUEditedClick } = useAppSelector((state) => state.table);
  const { currentScenario } = useAppSelector((state) => state.simulatorHome);
  const isDemandTransferenceEnabled = currentScenario?.is_dt_enabled !== false;

  const filterOutDemandTransferenceRows = (tableRows) =>
    isDemandTransferenceEnabled
      ? tableRows
      : tableRows.filter(
        (row) =>
          row?.pricing_is_edited !== true &&
          row?.pricing_is_not_default !== true &&
          row?.pricing_is_user_input !== true
      );

  const rows = filterOutDemandTransferenceRows(
    makeDataForTableNew(tableMetadaData.row).sort((p1, p2) =>
      p1.ppg > p2.ppg ? 1 : p1.ppg < p2.ppg ? -1 : 0
    )
  );
  const getRows = (tableRows) => {
    if (isSKUEditedClick) {
      return filterOutDemandTransferenceRows(
        makeDataForTableNew(
          getDataForEditedSimulatedRows(
            tableMetadaData,
            MODIFIED_ROW_INDICATOR_KEY.PRICING_IS_EDITED,
            MODIFIED_ROW_INDICATOR_KEY.PRICING_IS_NOT_DEFAULT,
            MODIFIED_ROW_INDICATOR_KEY.PRICING_IS_USER_INPUT
          )
        ).sort((p1, p2) => (p1?.ppg || '').localeCompare(p2?.ppg || ''))
      );
    }
    return filterOutDemandTransferenceRows(tableRows);
  };

  const tableState: Partial<TableState> = {
    columnVisibility: outputColumnVisibilityState
  };

  return columns.length ? (
    <div>
      <CollapsibleTable
        data={getRows(rows)}
        columns={columns}
        tableState={tableState}
        setHeightExplicitly
        externalColumnData={externalRetailerData}
        visibleColumns={visibleColumns}
        activeHeader={activeHeader}
      />
    </div>
  ) : (
    <TableSkeletonContainer rowLength={10} headerLength={6} />
  );
  ;
}

